<template>
  <main class="main-content" id="topDom">
    <section class="section">
      <ul class="breadcrumb">
        <li class="breadcrumb__li">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li --current">
          <span class="breadcrumb__text">{{ $t("i18n.news") }}</span>
        </li>
      </ul>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-8">
            <h1 class="mb-0 mt-3 mt-md-0" style="color: #666666;">
              {{ $t("i18n.news") }}
            </h1>
          </div>
        </div>
        <div class="row mt-6 mt-md-12">
          <div class="col-12">
            <router-link :to="{ name: 'NewsDetail', params: { form: topNew } }" class="featured-article">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="pr-0 pr-md-2">
                    <div class="featured-article__image">
                      <!-- <img :src="'http://a34.madpay.com/'+topNew.image" > -->
                      <img :src="'https://www.jiashengvac.com/'+topNew.image" >
                      <!-- <img :src="'http://admin.jiashengvac.com/'+topNew.image" > -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 d-flex align-items-center">
                  <div class="featured-article__content pl-3 pr-3 pr-md-0 pl-md-2">
                    <strong class="little-article__type mb-1 mb-md-2">
                      {{ topNew.create_time.substring(0, 10) }}
                      <span class="little-article__category">{{ topNew.cate }}</span>
                    </strong>
                    <h2 class="featured-article__title mb-1 mb-md-3">{{ topNew.title }}</h2>
                    <div class="little-article__text-container">
                      <p class="little-article__text" v-html="topNew.intro"></p>
                    </div>
                    <span class="featured-article__link text-link --big d-inline-flex">
                      {{ $t("i18n.readBtn") }}
                    </span>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row mt-3 mt-md-10" data-pagination="articles">
          <div class="col-12 col-md-4 pb-2 pb-md-10 d-flex" v-for="(item, index) of newsList" :key="index" :class="{ 'pagination-item-hidden': item.hidden }">
            <article class="little-article mx-0" v-hover="{ className: '--hover' }">
              <router-link :to="{ name: 'NewsDetail', params: { form: item } }" class="little-article__link">
                <div class="little-article__image">
                  <img :src="item.image" >
                </div>
                <strong class="little-article__type mb-1 mb-md-2">
                  {{ item.create_time.substring(0, 10) }}
                  <span class="little-article__category">{{ item.cate }}</span>
                </strong>
                <h3 class="little-article__title">{{ item.title }}</h3>
                <div class="little-article__text-container">
                  <p class="little-article__text" v-html="item.intro"></p>
                </div>
              </router-link>
            </article>
          </div>
        </div>
        <div class="row mt-4 mt-md-2" :class="{'pagination-item-hidden': showBtn}">
          <div class="col-6" style="width: 50%;cursor: pointer !important; " @click="showNews()">
            <div class="white-box__links">
              <a class="white-box__link">
                <strong class="white-box__link-label">
                  {{ $t("i18n.company") }}
                </strong>
                <h4 class="white-box__link-text">
                  {{ $t("i18n.seeMore") }}
                </h4>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import DropDown from "../components/DropDown";
import DropDownItem from "../components/DropDownItem";
import "../assets/css/main.css"
import {getNews} from "../api/api.js";
export default {
  name: "News",
  components: {DropDownItem, DropDown},
  data() {
    return {
      newsList: [],
      topNew: {},
      showBtn: false,
    }
  },
  created() {
    this.getNewList();
  },
  mounted () {
    this.goTop();
  },
  methods: {
    getNewList() {
      let type = this.$store.state.language === '中文' ? 1 : 2;
      getNews({ 
        type: type,
       }).then(res => {
        if (res && res.data && res.data.data) {
          this.topNew = res.data.data.splice(0, 1)[0]; 
          this.newsList = res.data.data;
          this.newsList.forEach((item,index) => {
            // item.image = "http://a34.madpay.com/"+ item.image;
            item.image = "https://www.jiashengvac.com/" + item.image;
            // item.image = "http://admin.jiashengvac.com/" + item.image;
            if(index >= 6) {
              item.hidden = true
            } else {
              item.hidden = false
            }
          })
        } else {
          this.newsList = [];
        }
      })
      this.showBtn = false
    },
    showNews() {
      this.newsList.forEach(item => {
        item.hidden = false
      });
      this.showBtn = true
    },
    showDrop() {
      this.showDropF = !this.showDropF;
    },
    changeRegion(region) {
      this.selectedRegion = region;
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // setTimeout(()=>{
      //   document.querySelector('#topDom').scrollIntoView({
      //     behavior: 'smooth'
      //   })
      // },400)
    }
  },
}
</script>

<style scoped>
.section {
  padding: 12rem 0;
  position: relative;
}
.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  top: 0;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #000;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown.--big {
  width: 100%;
}

.dropdown.--big .dropdown__wrapper {
  height: 6rem;
  min-width: 17rem;
  background: #fff;
  border: 0.1rem solid #e6e6e6;
  padding: 0 4.8rem 0 2rem;
  display: flex;
  position: relative;
  align-items: center;
  border-radius: 0.4rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);
  transition-property: all;
  transition-duration: .3s;
  transition-property: border-color, box-shadow;
}
.dropdown.--big .dropdown__current {
  font-size: 1.8rem;
  color: #505050;
}
.dropdown__wrapper:after {
  content: "";
  width: .8rem;
  height: .6rem;
  background-color: #990099;
  -webkit-mask: url(../assets/imgs/select-arrow.svg) no-repeat center;
  mask: url(../assets/imgs/select-arrow.svg) no-repeat center;
  position: absolute;
  right: 2rem;
  top: 50%;
  margin-top: -.3rem;
  transition-property: background;
  transition-duration: .3s;
}
.dropdown.--big .dropdown__list ul li a, .dropdown.--big .dropdown__list ul li span {
  min-height: 6rem;
  font-size: 1.8rem;
}
.dropdown__list ul li a.--highlight, .dropdown__list ul li span.--highlight {
  font-weight: 600;
  color: #000;
  background: #fafafa;
}
.dropdown__list ul li a, .dropdown__list ul li span {
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.6rem;
  line-height: 1.8rem;
}
.featured-article {
  display: block;
  padding-bottom: 3rem;
  border-bottom: 0.1rem solid #e6e6e6;
}
.featured-article__image {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 42rem;
  border-radius: 0.4rem;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
}
.featured-article__image img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  display: block;
  border-radius: 0.4rem;
  transition-duration: .45s;
  transition-timing-function: cubic-bezier(0,-.24,0,.51);
}
.g-content .little-article__type, .little-article__type {
  font-weight: 500;
  font-size: 1.3rem;
  color: #4c4c4c;
  letter-spacing: .035rem;
  text-transform: uppercase;
  line-height: 1.7rem;
  margin-bottom: 1rem;
  display: flex;
  transition: all .2s ease-in-out;
}
.g-content .little-article__type span, .little-article__type span {
  margin-left: 1rem;
}

.featured-article:hover .g-content .little-article__text, .featured-article:hover .little-article__text, .little-article__link:hover .g-content .little-article__text, .little-article__link:hover .little-article__text {
  color: #000;
  border-color: #990099;
}
.g-content .little-article__text, .little-article__text {
  font-weight: normal;
  color: #231815;
  line-height: 28px;
  font-size: 1.6rem;
  letter-spacing: -.02rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: 15.6rem;
  transition: all .2s ease-in-out;
}
.h2, h2 {
  font-weight: normal;
  color: #231815;

  font-size: 3rem;
  letter-spacing: -.02rem;
  line-height: 4.5rem;
  margin: 0;
  padding: 0;
}
.text-link.--big {
  /* font-size: 2rem; */
  font-size: 1.6rem;
  font-weight: 600;
  display: flex;
  padding-right: 3rem;
}
.text-link.--big::after {
  content: "";
  right: 0.5rem;
  position: absolute;
  width: 1.2rem;
  height: 1.4rem;
  margin-top: 0.7rem;
  background: url(../assets/imgs/arrow-right.png) no-repeat 50%;
  transition: all .2s ease-in-out;
}
.little-article {
  margin: 0 1.5rem;
  position: relative;
  border-bottom: 0.1rem solid #e6e6e6;
  min-width: 100%;
  transition: all .2s ease-in-out;
}


.little-article:hover {
  border-bottom-color: transparent
}

.block-case-studies__articles .little-article:hover {
  border-bottom-color: #80ba27
}

.little-article.--hovered {
  position: relative;
  z-index: 10
}

.little-article.--hovered .little-article__link {
  position: absolute
}

.little-article.--hovered .little-article__link:before {
  filter: alpha(opacity=1);
  -moz-opacity: 1;
  -khtml-opacity: 1;
  opacity: 1
}

.little-article.--hovered .little-article__link .show-hover {
  display: block
}

.featured-article:hover .g-content .little-article__type,
.featured-article:hover .little-article__type,
.little-article__link:hover .g-content .little-article__type,
.little-article__link:hover .little-article__type {
  color: #000
}

.featured-article:hover .g-content .little-article__text,
.featured-article:hover .little-article__text,
.little-article__link:hover .g-content .little-article__text,
.little-article__link:hover .little-article__text {
  color: #000;
  border-color: #990099;
   
}
.little-article.--hovered .little-article__text-container {
  padding-bottom: 1rem
}

.little-article.--hovered .little-article__text {
  overflow: visible;
  max-height: none;
  display: block
}

.little-article__link {
  display: flex;
  position: relative;
  z-index: 5;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
}
.little-article__link:before {
  content: "";
  width: calc(100% + 3rem);
  height: calc(100% + 3rem);
  position: absolute;
  z-index: -1;
  top: -1.5rem;
  left: -1.5rem;
  background: #fff;
  border-bottom: 0.1rem solid #990099;
  box-shadow: 0 2rem 4rem 0 rgba(0,0,0,.1);
  transition-duration: .45s;
  filter: alpha(opacity = 0);
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
}
.little-article__image {

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 3rem;
  height: 20rem;
  border-radius: 0.4rem;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
}
.little-article__image img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  display: block;
  transition-duration: .45s;
  transition-timing-function: cubic-bezier(0,-.24,0,.51);
}
.little-article:hover .little-article__image img {
  transform: scale(1.08);
}
img {
  max-width: 100%;
}
.g-content .little-article__title, .little-article__title {
  /* font-weight: 600; */
  font-size: 2rem;
  font-weight: 550;
  color: #000;
  letter-spacing: -.02rem;
  line-height: 2.6rem;
  margin: 0 0 1rem;
}
.little-article__text-container {
  padding-bottom: 3rem;
}
.pagination-item-hidden:not(.pagination-item-visible) {
  display: none !important;
}
.pagination-item-hidden {
  transition: all .2s ease-in-out;
  opacity: 0;
  visibility: hidden;
}
.white-box__links {
  position: relative;
  z-index: 2;
  background: #fff;
  border: 0.1rem solid #e6e6e6;
  display: flex;
  min-height: 18rem;
  overflow: hidden;
  border-radius: 0.4rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);
}
.white-box__link:last-child {
  border: 0 !important;
}
.white-box__link {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 5rem;
  border-right: 0.1rem solid #e6e6e6;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-label, .white-box__link-label {
  font-weight: 500;
  font-size: 1.3rem;
  color: black;
  letter-spacing: .035rem;
  text-transform: uppercase;
  display: block;
  line-height: 1.7rem;
  margin-bottom: 1rem;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text, .white-box__link-text {
  font-weight: 500;
  font-size: 3rem;
  color: #990099;
  letter-spacing: -.015rem;
  line-height: 3.2rem;
  position: relative;
  padding-right: 1.5rem;
  margin: 0;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text:after, .white-box__link-text:after {
  content: "";
  position: absolute;
  padding-right: 2rem;
  right: 0;
  width: 0.8rem;
  height: 1.4rem;
  top: 1.2rem;
  background: url(../assets/imgs/arrow-right.png) no-repeat 50%;
  transition: all .2s ease-in-out;

}

.featured-article:hover .featured-article__image img {
    transform: scale(1.08);
}

.text-link:hover {
    color: #000;
}

.text-link.--big:hover:after {
    right: 0;
}

.little-article__link:hover:before {
  opacity: 1;
} 

.white-box__link:hover {
    background: #fafafa;
}

.white-box__link:hover .g-content .white-box__link-text,
.white-box__link:hover .white-box__link-text {
    color: #000;
}

.white-box__link:hover .g-content .white-box__link-text:after,
.white-box__link:hover .white-box__link-text:after {
    right: -.5rem;
}

@media (max-width: 768px) {
  .little-article {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/News.vue